<loader *ngIf="!data"></loader>

<div *ngIf="data" class="body-container">

  <div class="first-col-container">
    <dash-order-summary *ngIf="displayLastOrdersSummary"></dash-order-summary>

    <dash-supply-summary-lab
      *ngIf="displayLabSupplyOrdersSummary"
    ></dash-supply-summary-lab>

    <div
      *ngIf="displayClinicSupplySummary"
      class="clinic-supply-summary-container"
    >
      <div class="sup-container">
        <dash-supply-status></dash-supply-status>
      </div>
      <div class="del-container">
        <dash-delivery-status></dash-delivery-status>
      </div>
    </div>

    <dash-news *ngIf="clinicUserSw && displayNews"></dash-news>
  </div>

  <div class="sec-col-container">
    <dash-invoices-summary *ngIf="displayInvoices"></dash-invoices-summary>

    <dash-chat-summary></dash-chat-summary>

    <dash-tasks *ngIf="displayTasks"></dash-tasks>

    <dash-news *ngIf="!clinicUserSw && displayNews"></dash-news>
  </div>
</div>

<div *ngIf="data && displayBanners">
  <dash-banners></dash-banners>
</div>
